//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import BasicBtn from "../../../../component/button/BasicBtn";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MemOut() {
    //페이지 이동
    const navigate = useNavigate();
    const memOutDetail = () => {
        navigate(`detail`);
    };
    const goBack = () => {
        navigate(-1);
    };

    return (
        <Wrap>
            <Content>
                <Text>
                    최신도님,
                    <br />
                    정말 회원 탈퇴하시겠습니까?
                </Text>
                <BtnWrap>
                    <BasicBtn
                        onClick={() => {
                            memOutDetail();
                        }}
                        gray={true}
                        text="예"
                    />
                    <BasicBtn
                        onClick={() => {
                            goBack();
                        }}
                        text="아니오"
                    />
                </BtnWrap>
            </Content>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    display: flex;
`;
const Content = styled.div`
    max-width: calc(100vw * (500 / 1920));
    margin: calc(100vw * (180 / 1920)) auto;

    @media screen and (max-width: 1300px) {
        max-width: calc(100vw * (500 / 1300));
        margin: calc(100vw * (180 / 1300));
    }

    @media screen and (max-width: 900px) {
        max-width: ${M(378)};
        margin: ${M(180)} auto;
    }
`;
const Text = styled.p`
    font-size: calc(100vw * (25 / 1920));
    text-align: center;

    margin-bottom: calc(100vw * (58 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
        margin-bottom: calc(100vw * (58 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: ${M(30)};
    }
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;

    margin-top: calc(100vw * (40 / 1920));

    & > p {
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (40 / 1300));

        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(40)};

        & > p {
            width: ${M(160)};
        }

        & > p:first-child {
            margin-right: ${M(19)};
        }
    }
`;
